export const WIDGET_BASE_CSS = `
@font-face {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 200 800;
  font-display: swap;
  src: url("https://fonts.gstatic.com/s/manrope/v15/xn7gYHE41ni1AdIRggqxSuXd.woff2") format("woff2");
}

:host, .pfb-root {
  all: initial;
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  color: #0f172a;
}

.pfb-root *, .pfb-root *::before, .pfb-root *::after {
  box-sizing: border-box;
}

.pfb-root {
  position: fixed;
  --pfb-heading: #262626;
  z-index: 2147483000;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pfb-position-bottom-right { right: 16px; bottom: 16px; align-items: flex-end; }
.pfb-position-bottom-left { left: 16px; bottom: 16px; align-items: flex-start; }
.pfb-position-top-right { right: 16px; top: 16px; align-items: flex-end; flex-direction: column-reverse; }
.pfb-position-top-left { left: 16px; top: 16px; align-items: flex-start; flex-direction: column-reverse; }

.pfb-trigger {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  border: 0;
  border-radius: 999px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 550;
  letter-spacing: 0.01em;
  padding: 11px 16px;
  cursor: pointer;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.2);
  transition: transform 0.16s ease, box-shadow 0.16s ease;
}

.pfb-trigger:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.24);
}

.pfb-trigger-icon-only {
  padding: 11px;
  gap: 0;
}

.pfb-trigger-icon {
  position: absolute;
  inset: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(255,255,255,0.96);
  transition: opacity 0.16s ease, transform 0.16s ease;
}

.pfb-trigger-icon svg {
  width: 19px;
  height: 19px;
}

.pfb-trigger-icon-slot {
  position: relative;
  width: 19px;
  height: 19px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pfb-trigger-logo {
  position: absolute;
  inset: 0;
  margin: auto;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  object-fit: cover;
  opacity: 0;
  transform: scale(0.86);
  transition: opacity 0.16s ease, transform 0.16s ease;
}

.pfb-trigger:hover .pfb-trigger-icon,
.pfb-trigger:focus-visible .pfb-trigger-icon {
  opacity: 0;
  transform: scale(0.86);
}

.pfb-trigger:hover .pfb-trigger-logo,
.pfb-trigger:focus-visible .pfb-trigger-logo {
  opacity: 1;
  transform: scale(1);
}

.pfb-logo {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  object-fit: cover;
}

.pfb-panel {
  width: min(92vw, 390px);
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  box-shadow: 0 28px 60px rgba(15, 23, 42, 0.14);
  padding: 14px;
  animation: pfb-slide-up 150ms ease-out;
}

.pfb-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.pfb-header-title-wrap {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.pfb-title {
  margin: 0;
  font-size: 14px;
  font-weight: 550;
  color: var(--pfb-heading);
}

.pfb-subtitle {
  margin: 2px 0 0;
  font-size: 11px;
  color: #6b7280;
}

.pfb-close {
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 999px;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}

.pfb-selection-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.pfb-card {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
  text-decoration: none;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 11px;
  background: #fcfcfd;
  cursor: pointer;
  transition: border-color 120ms ease, transform 120ms ease, background 120ms ease;
}

.pfb-card:hover {
  border-color: color-mix(in oklab, var(--pfb-brand, #2563eb) 35%, #e5e7eb 65%);
  background: #ffffff;
  transform: translateY(-1px);
}

.pfb-card:disabled {
  cursor: not-allowed;
  opacity: 0.55;
  transform: none;
}

.pfb-card:disabled:hover {
  border-color: #e5e7eb;
  background: #fcfcfd;
}

.pfb-card-title {
  font-size: 12px;
  font-weight: 550;
  color: var(--pfb-heading);
}

.pfb-card-meta {
  font-size: 11px;
  color: #6b7280;
}

.pfb-selection-note {
  grid-column: 1 / -1;
  margin: 0;
  font-size: 11px;
  color: #6b7280;
}

.pfb-form {
  display: grid;
  gap: 10px;
}

.pfb-label {
  display: block;
  font-size: 11px;
  font-weight: 550;
  color: #374151;
  margin-bottom: 5px;
}

.pfb-input, .pfb-textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 9px 10px;
  font-size: 13px;
  color: #111827;
  background: #fff;
}

.pfb-input:focus, .pfb-textarea:focus {
  outline: 2px solid color-mix(in oklab, var(--pfb-brand, #2563eb) 35%, white 65%);
  outline-offset: 1px;
  border-color: color-mix(in oklab, var(--pfb-brand, #2563eb) 45%, #d1d5db 55%);
}

.pfb-textarea {
  min-height: 96px;
  resize: vertical;
}

.pfb-small-btn {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  color: #374151;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
}

.pfb-small-btn svg {
  width: 16px;
  height: 16px;
}

.pfb-upload-btn {
  position: relative;
  overflow: hidden;
}

.pfb-upload-btn input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.pfb-file-preview-wrap {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 48px;
}

.pfb-file-preview {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.pfb-file-preview-remove {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  border: 0;
  border-radius: 50%;
  background: #ef4444;
  color: #fff;
  font-size: 12px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.pfb-consent {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  font-size: 11px;
  line-height: 1.35;
  color: #4b5563;
}

.pfb-consent input {
  margin-top: 2px;
}

.pfb-error {
  font-size: 12px;
  color: #b91c1c;
}

.pfb-info {
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
  border-radius: 9px;
  padding: 8px 10px;
  font-size: 12px;
}

.pfb-success {
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  color: #166534;
  border-radius: 9px;
  padding: 8px 10px;
  font-size: 12px;
}

.pfb-thankyou {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 18px 14px;
  text-align: center;
  background: #ffffff;
}

.pfb-thankyou-icon {
  width: 38px;
  height: 38px;
  margin: 0 auto 10px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ecfdf3;
  color: #15803d;
  font-size: 20px;
  font-weight: 550;
}

.pfb-thankyou-title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 550;
  color: #111827;
}

.pfb-thankyou-text {
  margin: 0;
  font-size: 12px;
  color: #4b5563;
}

.pfb-thankyou-actions {
  margin-top: 14px;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.pfb-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.pfb-actions-left,
.pfb-actions-right {
  display: flex;
  gap: 8px;
}

.pfb-btn {
  border: 0;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 550;
  cursor: pointer;
}

.pfb-btn-secondary {
  background: #f3f4f6;
  color: #374151;
}

.pfb-btn-primary {
  background: var(--pfb-brand, #2563eb);
  color: #fff;
}

.pfb-btn-google {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  background: #fff;
  color: #374151;
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 2px rgba(0,0,0,.06);
  font-size: 14px;
  font-weight: 550;
  padding: 9px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
}
.pfb-btn-google:hover {
  background: #f9fafb;
}

.pfb-auth-gate {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 4px 4px;
  gap: 0;
}
.pfb-auth-gate-icon {
  color: #6b7280;
  margin-bottom: 12px;
}
.pfb-auth-gate-title {
  font-size: 15px;
  font-weight: 550;
  color: #111827;
  margin: 0 0 6px;
}
.pfb-auth-gate-body {
  font-size: 13px;
  color: #6b7280;
  margin: 0 0 16px;
  line-height: 1.5;
}

.pfb-branding {
  border-top: 1px solid #f3f4f6;
  margin-top: 10px;
  padding-top: 9px;
  text-align: right;
  font-size: 10px;
  color: #9ca3af;
}

.pfb-similar {
  display: flex;
  flex-direction: column;
  gap: 6px;
  animation: pfb-slide-up 150ms ease-out;
  max-height: 168px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #d1d5db transparent;
}

.pfb-similar::-webkit-scrollbar {
  width: 4px;
}

.pfb-similar::-webkit-scrollbar-track {
  background: transparent;
}

.pfb-similar::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}

.pfb-similar-label {
  font-size: 11px;
  font-weight: 550;
  color: #6b7280;
  letter-spacing: 0.01em;
}

.pfb-similar-item {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 9px;
  padding: 8px 10px;
  background: #fcfcfd;
  transition: border-color 120ms ease, background 120ms ease;
}

.pfb-similar-item:hover {
  border-color: color-mix(in oklab, var(--pfb-brand, #2563eb) 25%, #e5e7eb 75%);
  background: #fff;
}

.pfb-similar-vote-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  border: 1px solid #d1d5db;
  border-radius: 7px;
  background: #fff;
  color: #6b7280;
  padding: 5px 8px;
  font-size: 11px;
  font-weight: 550;
  cursor: pointer;
  min-width: 36px;
  transition: border-color 120ms ease, color 120ms ease, background 120ms ease;
  flex-shrink: 0;
}

.pfb-similar-vote-btn:hover {
  border-color: var(--pfb-brand, #2563eb);
  color: var(--pfb-brand, #2563eb);
  background: color-mix(in oklab, var(--pfb-brand, #2563eb) 6%, white 94%);
}

.pfb-similar-vote-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pfb-similar-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.pfb-similar-title {
  font-size: 12px;
  font-weight: 550;
  color: #1f2937;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pfb-similar-status {
  font-size: 10px;
  font-weight: 550;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.pfb-status-planned { color: #2563eb; }
.pfb-status-in-progress { color: #d97706; }
.pfb-status-reviewing { color: #7c3aed; }
.pfb-status-pending { color: #6b7280; }

.pfb-similar-divider {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 2px 0;
}

.pfb-similar-divider::before,
.pfb-similar-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #e5e7eb;
}

.pfb-similar-divider span {
  font-size: 10px;
  color: #9ca3af;
  white-space: nowrap;
}

.pfb-upvoted-thankyou {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #d1fae5;
  border-radius: 10px;
  padding: 14px;
  background: #f0fdf4;
  animation: pfb-slide-up 150ms ease-out;
}

.pfb-upvoted-icon {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dcfce7;
  color: #15803d;
}

.pfb-upvoted-msg {
  font-size: 12px;
  color: #374151;
  line-height: 1.45;
}

.pfb-upvoted-msg strong {
  color: #15803d;
}

.pfb-upvote-comment {
  min-height: 64px;
  background: #fff;
}

.pfb-upvoted-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

@keyframes pfb-slide-up {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 640px) {
  .pfb-position-bottom-right,
  .pfb-position-bottom-left,
  .pfb-position-top-right,
  .pfb-position-top-left {
    right: 10px;
    left: 10px;
    bottom: 10px;
    top: auto;
    align-items: stretch;
    flex-direction: column;
  }

  .pfb-panel {
    width: 100%;
  }

  .pfb-selection-grid {
    grid-template-columns: 1fr;
  }

  .pfb-attachment-row {
    flex-wrap: wrap;
  }

  .pfb-actions {
    flex-wrap: wrap;
  }

  .pfb-actions-left,
  .pfb-actions-right {
    width: 100%;
  }

  .pfb-actions-right {
    justify-content: flex-end;
  }

  .pfb-trigger {
    align-self: flex-end;
    padding: 12px;
  }

  .pfb-trigger > span:last-child {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pfb-panel,
  .pfb-trigger,
  .pfb-card {
    animation: none !important;
    transition: none !important;
  }
}
`;
